import React from "react";
import styles from "./Fatca.module.sass";
import Tooltip from "../../ui/Tooltip/Tooltip";
import RadioGroup from "../../ui/RadioGroup/RadioGroup";
import theme from "../../../App.module.sass";
import Input, { inputType } from "../../ui/Input/Input";
import validation from "../../../utils/validation";
import masks from "../../../utils/masks";
import api from "../../../utils/api";
import formatters from "../../../utils/select-formatters";

class Fatca extends React.Component {
  state = {
    fatca: "N",
    paisNascimento: "",
    flagPaisObrigacao: "N",
    paisObrigacaoFiscal: "",
    paisResidenciaFiscal: "",
    nif: "",
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onChange({ ...this.state });
    }
  }

  render() {
    return (
      <div className={styles.Fatca}>
        <div className={"flex-row"}>
          <p>
            <b>
              No exterior, você possui investimentos, rendimentos ou algum tipo
              de obrigação fiscal, vínculo trabalhista, familiar, residencial ou
              de nascimento?
            </b>
            <Tooltip>
              <p>
                FATCA é quando você tem obrigações fiscais, investimentos ou
                rendimentos fora do país. Isso inclui ter vínculos trabalhistas,
                familiares, residenciais ou de nascimento no exterior.
              </p>
            </Tooltip>
          </p>
        </div>

        <RadioGroup
          options={["Sim", "Não"].map((el) => ({
            value: el === "Sim" ? "S" : "N",
            text: el,
          }))}
          value={this.state.fatca}
          onChanged={(value) => {
            this.setState({ fatca: value });
          }}
        />

        {this.state.fatca === "S" && (
          <React.Fragment>
            <div className={theme.row}>
              <Input
                className={theme.col50}
                typeDocument="País de nascimento"
                onSelect={(value) => {
                  this.setState({ paisNascimento: value });
                }}
                optionsUrl={api.endpoints.COUNTRY}
                formatter={formatters.default}
                value={this.state.paisNascimento}
                type={inputType.AUTOCOMPLETE}
                queryKey="pais"
                async
                validationRules={[validation.required]}
              />
              <Input
                className={theme.col50}
                typeDocument="País de residência fiscal"
                onSelect={(value) => {
                  this.setState({ paisResidenciaFiscal: value });
                }}
                optionsUrl={api.endpoints.COUNTRY}
                formatter={formatters.default}
                value={this.state.paisResidenciaFiscal}
                type={inputType.AUTOCOMPLETE}
                queryKey="pais"
                async
                validationRules={[validation.required]}
              />
            </div>
            <p>
              <b>
                País com obrigações fiscais por motivo de residência ou
                cidadania diferente do país de contratação do consórcio?
              </b>
            </p>
            <RadioGroup
              options={["Sim", "Não"].map((el) => ({
                value: el === "Sim" ? "S" : "N",
                text: el,
              }))}
              value={this.state.flagPaisObrigacao}
              onChanged={(value) => {
                this.setState({ flagPaisObrigacao: value });
              }}
            />

            {this.state.flagPaisObrigacao === "S" && (
              <React.Fragment>
                <div className={theme.row}>
                  <Input
                    className={theme.col50}
                    typeDocument="País de obrigações fiscais"
                    onSelect={(value) => {
                      this.setState({ paisObrigacaoFiscal: value });
                    }}
                    optionsUrl={api.endpoints.COUNTRY}
                    formatter={formatters.default}
                    value={this.state.paisObrigacaoFiscal}
                    type={inputType.AUTOCOMPLETE}
                    queryKey="pais"
                    async
                    validationRules={[validation.required]}
                  />
                  <Input
                    className={theme.col50}
                    typeDocument="Número de identificação fiscal"
                    value={this.state.nif}
                    onChange={(value) => {
                      this.setState({ nif: value });
                    }}
                    type="text"
                    mask={masks.numberOnly}
                    validationRules={[
                      validation.required,
                      validation.numbersOnly,
                    ]}
                  />
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Fatca;
